import { render, staticRenderFns } from "./serviceApplyOrder.vue?vue&type=template&id=12566f25&scoped=true&"
import script from "./serviceApplyOrder.vue?vue&type=script&lang=js&"
export * from "./serviceApplyOrder.vue?vue&type=script&lang=js&"
import style0 from "./serviceApplyOrder.vue?vue&type=style&index=0&id=12566f25&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12566f25",
  null
  
)

export default component.exports